import lodash from "lodash";
import moment from "moment";
//redux

export const getData = (incomeStaff, branches, users) => {
  // -------------------------- VAR --------------------------
  let data = [];
  incomeStaff?.forEach((item) => {
    item?.staffs.forEach((staff) => {
      const user_name =
        users?.find((user) => user.id === staff.userId)?.username || "(empty)";
      const full_name = staff.fullName;
      const branch =
        branches?.find((branch) => branch.id === item.branch)?.shopId ||
        "(empty)";
      // console.log({ item });
      const date = moment(item?.date, "DD/MM/YYYY").toDate();
      const income = lodash.sumBy(
        staff.income,
        (valueRange) => valueRange.value
      );
      const staffRow = {
        user_name,
        full_name,
        branch,
        date,
        income,
      };
      data.push(staffRow);
    });
  });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return data;
};
